{"accountSettings":"Account settings","addReasonCodes":"Add Reason Codes","notifications":"Notifications","callHistory":"Call History"}